// ** Custom Hooks
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const { t } = useTranslation()
  return (
    <p className='clearfix mb-0'>
      <span className='float-md-start d-block d-md-inline-block mt-25'>
        COPYRIGHT © {new Date().getFullYear()}{' '}
        <a href='https://optimahr.io' target='_blank' rel='noopener noreferrer'>
          OPTIM<span style={{color: "#0CC2AA"}}>A</span> HR
        </a>
        <span className='d-none d-sm-inline-block'>, {t("All rights Reserved")}</span>
      </span>
      <span className='float-md-end d-none d-md-block'>
        Release 0
      </span>
    </p>
  )
}

export default Footer
